"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createOasisPlayer = exports.loadScriptOnce = exports.VERSION = void 0;
var tslib_1 = require("tslib");
require("promise-polyfill");
var loadjs_1 = tslib_1.__importDefault(require("loadjs"));
var load_player_1 = require("./load-player");
// 15.15.4 gets replaced with the current version before the package is published
exports.VERSION = '15.15.4';
// loadScriptOnce: Inspect loaded page scripts skipping duplicate loading
function loadScriptOnce(url, loader) {
    if (loader === void 0) { loader = loadjs_1.default; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var hasScriptLoaded;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hasScriptLoaded = function (element) { return element.src === url; };
                    if (!!Array.from(document.scripts).some(hasScriptLoaded)) return [3 /*break*/, 2];
                    return [4 /*yield*/, loader(url, {
                            returnPromise: true,
                            numRetries: 3,
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
exports.loadScriptOnce = loadScriptOnce;
function createOasisPlayer(config) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var playerPerformance, polyfillIoUrl;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!config.id)
                        throw new Error('No id provided');
                    if (!config.element)
                        throw new Error('No element provided');
                    playerPerformance = [
                        {
                            name: 'oasisInit',
                            timestamp: Date.now(),
                        },
                    ];
                    polyfillIoUrl = 'https://polyfill.io/v3/polyfill.min.js?features=atob%2CObject.assign%2CFunction.prototype.bind%2Cfetch';
                    if (config.polyfillIoVersion) {
                        polyfillIoUrl = "".concat(polyfillIoUrl, "&version=").concat(config.polyfillIoVersion);
                    }
                    return [4 /*yield*/, loadScriptOnce(polyfillIoUrl)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, (0, load_player_1.loadPlayer)({ loadScript: loadjs_1.default, playerPerformance: playerPerformance, config: config, VERSION: exports.VERSION })];
            }
        });
    });
}
exports.createOasisPlayer = createOasisPlayer;
exports.default = createOasisPlayer;
//# sourceMappingURL=index.js.map